<template>
  <v-card>
    <v-card-title>
      <span class="headline">Sede cantiere</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
           <!-- required
              :rules="[
                () => !!this.headquarterDetails.indirizzo || 'This field is required',
              ]" -->
          <v-col cols="12" sm="6">
            <v-text-field
              label="Indirizzo"
             
              v-model="headquarterDetails.indirizzo"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Città"
              v-model="headquarterDetails.citta"
       
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Provincia"
              v-model="headquarterDetails.provincia"
         
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="CAP"
              v-model="headquarterDetails.cap"
        
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row v-if="Errors != ''">
        <v-alert border="bottom" color="red" dense outlined type="error">{{
          Errors
        }}</v-alert>
      </v-row> -->
        <!-- MAP -->
        <v-row>
          <v-col cols="12" v-if="showMap">
            <Map
              v-bind:indirizzo="this.headquarterDetails.indirizzo"
              v-bind:citta="this.headquarterDetails.citta"
            ></Map>
          </v-col>
        </v-row>
        <!-- MAP -->
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style>
</style>

<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import Map from "../CustomComponentsUI/Map";
export default {
  props: ["headquarterDetails"],
  components: { Map },
  data: () => ({
    headquarters: [],
    editedIndex: -1,
    dialog: false,
    dialogDelete: false,
    //Errors: "",

    editedHeadquarter: {
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
    },
  }),
  computed: {
    showMap() {
      return (
        this.headquarterDetails.indirizzo != "" &&
        this.headquarterDetails.citta != "" &&
        this.headquarterDetails.provincia != "" &&
        this.headquarterDetails.cap != ""
      );
    },
    // Errors: {
    //   get() {
    //     if (
    //       this.editedHeadquarter.indirizzo != "" &&
    //       this.editedHeadquarter.citta != "" &&
    //       this.editedHeadquarter.provincia != "" &&
    //       this.editedHeadquarter.cap != ""
    //     )
    //       return "Tutti i campi sono obbligatori";

    //     return "";
    //   },
    // },
  },

  methods: {
    save(companyAlias, clienteId) {
      EasyPlanClient.Headquarters.Insert(
        companyAlias,

        this.headquarterDetails.indirizzo,
        this.headquarterDetails.cap,
        this.headquarterDetails.citta,
        this.headquarterDetails.provincia,
        clienteId
      )
        .then((res) => {
          console.debug("risposta add headquarter:");
          console.debug(res);
          this.$emit("headquarterAdded", res.data.data);
          // this.loadHeadquarters();
          this.headquarterDetails.indirizzo = "";
          this.headquarterDetails.cap = "";
          this.headquarterDetails.citta = "";
          this.headquarterDetails.provincia = "";
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });

      this.dialog = false;
    },

 

    saveFrmEditCustomer() {
      // (this.headquarterDetails.indirizzo = this.editedHeadquarter.indirizzo),
      //   (this.headquarterDetails.cap = this.editedHeadquarter.cap),
      //   (this.headquarterDetails.citta = this.editedHeadquarter.citta),
      //   (this.headquarterDetails.provincia = this.editedHeadquarter.provincia);

      this.$emit("headquarterAdded");

      // this.editedHeadquarter.indirizzo = "",
      // this.editedHeadquarter.cap = "",
      // this.editedHeadquarter.citta = "",
      // this.editedHeadquarter.provincia = ""
    },
  },
};
</script>

